import { render, staticRenderFns } from "./DocumentsOtpModal.vue?vue&type=template&id=242fdc1e&scoped=true"
import script from "./DocumentsOtpModal.vue?vue&type=script&lang=js"
export * from "./DocumentsOtpModal.vue?vue&type=script&lang=js"
import style0 from "./DocumentsOtpModal.vue?vue&type=style&index=0&id=242fdc1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242fdc1e",
  null
  
)

export default component.exports